import Quill from 'quill';

interface CustomButtonOptions {
  label: string;
  callback: () => void;
}

class CustomButtonModule {
  quill: Quill;
  options: CustomButtonOptions;
  toolbar: any;

  constructor(quill: Quill, options: CustomButtonOptions) {
    this.quill = quill;
    this.options = options;
    this.toolbar = this.quill.getModule('toolbar');

    this.init();
  }

  init() {
    // Create a custom button
    const button = document.createElement('div');
    button.classList.add('ql-custom-button');
    button.textContent = this.options.label;

    // Add click event listener
    button.addEventListener('click', (event: Event) => {
      event.preventDefault();
      this.options.callback();
    });

    // Add the button to the toolbar
    const toolbarContainer = this.quill.getModule('toolbar').container;
    if (toolbarContainer) {
      const wrapper = document.createElement('span');
      wrapper.classList.add('ql-custom-button-wrapper');
      wrapper.appendChild(button);
      toolbarContainer.appendChild(wrapper);
    }
  }
}

Quill.register('modules/customButton', CustomButtonModule);

export default CustomButtonModule;
